<template>
  <section class="mt-3" id="newPolicy">
    <div class="container-fluid form-container" id="newPolicy-container">
      <!-- Form -->
      <policy-form ref="policyFormChild" :formConfigType="formConfigType" :readOnly="false" :anchorsOffset="72"
        @form-submit="onFormSubmit" id="newPolicy-policyForm">
      </policy-form>
    </div>
  </section>
</template>

<script>
import PolicyForm from '../case/PolicyForm';
import RestService from '../../service/RestService';
import GeneralConfigService from '../../service/GeneralConfigService';
import FormConfigService from '../../service/FormConfigService';

export default {
  components: { PolicyForm },
  props: ['policyType'],
  data: function () {
    return {
      rest: this.initRestService(),
      productLine: this.policyType.toUpperCase(),
      enabledProductLines: []
    }
  },
  async beforeMount() {
    this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
    if (!this.enabledProductLines.find(p => p.name === this.productLine)) this.$router.push('/404');
  },
  computed: {
    formConfigType() {
      return this.productLine + FormConfigService.typeNewPolicySuffix;
    }
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async onFormSubmit(submissionData) {
      let formattedSubmissionData = this.formatCovers(submissionData)
      let response = await this.rest.createNewCase(formattedSubmissionData, undefined, undefined, true, this.$route.query.customerUniqueId);
      this.$router.push('/case/' + response.data.policyCaseHeaderId);
    },
    // todo delete the method below once the new api is being used https://paston.atlassian.net/browse/AA-1400
    formatCovers(submissionData) {
      // transform covers from an object schema to an array
      if (submissionData.covers) {
        let coversArr = Object.keys(submissionData.covers)
          .filter(cover => submissionData.covers[cover])
          .map(cover => ({ type: cover }));
        submissionData.covers = coversArr;
      }
      function getTrueKey(innerMap) {
        for (const [innerKey, value] of Object.entries(innerMap)) {
          if (value) {
            return innerKey;
          }
        }
        return null;
      }

      const map = submissionData.map;

      // Remove inner objects with values set to false
      for (const key of Object.keys(map)) {
        const value = map[key];
        if (typeof value === 'object') {
          for (const innerKey in value) {
            if (value.hasOwnProperty(innerKey) && value[innerKey] === false) {
              delete value[innerKey];
            }
          }
          // Remove the entire key if all values are false
          if (Object.keys(value).length === 0) {
            delete map[key];
          }
        }
      }
      // Update submissionData
      for (const [key, value] of Object.entries(map)) {
        if (typeof value === 'object') {
          const trueKey = getTrueKey(value);
          if (trueKey !== null) {
            map[key] = trueKey;
          }
        }
      }
      return submissionData;
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/new/NewPolicy.vue